/* eslint-disable */
import {
  Box,
  Button,
  Card,
  Checkbox,
  Container,
  FormControl,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import InfoTooltip from '../InfoTooltip';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { SlCloudUpload } from 'react-icons/sl';
import Swal from 'sweetalert2';
import { DatePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import { LoadingButton } from '@mui/lab';
import {
  createAssignRefill,
  getAllRefill,
  createQuestion,
  getBnbList,
  uploadFile,
  getAllCleaningItem,
  createCleaningItem,
  createAssignCleaning,
  createExtraCleaningRequest,
} from '../../helper/backend_helper';

const AddExtraCleaningRequest = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ profileImage: null });
  const [cleaningItem, setCleaningItem] = useState('');
  const [time, setTime] = useState('');
  const [price, setPrice] = useState(0);
  const [bnb, setBnB] = useState('');
  const [cleaning, setCleaning] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const handleStartDateChange = (newValue) => {
    setStartDate(newValue); // Update state when date is selected
  };
  const [loading, setLoading] = useState(false);
  const handleFileChange = (e) => {
    const { name, files } = e.target;

    setFormData({
      ...formData,
      [name]: files[0],
    });
  };

  const [users, setUsers] = useState([]);
  console.log('users', users);
  async function fetchData() {
    try {
      const usersResponse = await getBnbList();
      setUsers(usersResponse?.data?.data);
      setUsers(
        usersResponse?.data?.data?.sort((a, b) => {
          const nameA = a.BnBShortName?.toLowerCase() || ''; // Handle undefined or null values
          const nameB = b.BnBShortName?.toLowerCase() || '';
          return nameA.localeCompare(nameB); // Sort alphabetically
        })
      );
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  async function fetchRefill() {
    try {
      const usersResponse = await getAllCleaningItem();
      // setCleaning(usersResponse?.data?.data);
      setCleaning(
        usersResponse?.data?.data?.sort((a, b) => {
          const nameA = a.name?.toLowerCase() || ''; // Handle undefined or null values
          const nameB = b.name?.toLowerCase() || '';
          return nameA.localeCompare(nameB); // Sort alphabetically
        })
      );
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  useEffect(() => {
    fetchData();
    fetchRefill();
  }, []);
  console.log(new Date(startDate).toDateString(), 'startDate');
  const handleSave = async () => {
    try {
      setLoading(true);

      if (!bnb) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'BnB  is required',
        });
        setLoading(false);
        return;
      }
      if (!cleaningItem) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Cleaning Item is required',
        });
        setLoading(false);
        return;
      }
      if (!startDate) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Date is required',
        });
        setLoading(false);
        return;
      }

      if (!time) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Time is required',
        });
        setLoading(false);
        return;
      }

      const selectedDate = startDate?.format ? startDate.format('YYYY-MM-DD') : moment(startDate).format('YYYY-MM-DD');
      const Data = {
        bnb,
        itemName: cleaningItem,
        // DatePicker returns a Dayjs value; format it directly so future requests stay on the selected calendar day.
        date: `${selectedDate}T00:00:00.000Z`,
        time,
        price: 0,
      };

      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await createExtraCleaningRequest(Data);

      // Show success message
      Swal.fire({
        icon: 'success',
        title: 'Request created successfully',
      });
      // setCleaningItem('');
      // setPrice(0);
      // setBnB([]);
      navigate(-1);

      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `${error?.response?.data?.errors[0]?.message}`,
      });
    }
  };

  return (
    <>
      <Helmet>
        <title> Add Cleaning Request </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Stack
          onClick={() => navigate(-1)}
          gap={3}
          sx={{ cursor: 'pointer', mb: 3 }}
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <FaArrowLeftLong size={24} />
          <Typography variant="h4">Add Cleaning Request</Typography>
        </Stack>

        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { width: '50ch' },
          }}
          noValidate
          autoComplete="off"
        >
          <Stack>
            <FormControl
              sx={{
                width: { xs: '100%', md: 490 },
              }}
            >
              <FormLabel sx={{ mb: 1 }}>BnB <InfoTooltip title="The property that needs this one-off extra cleaning outside the regular schedule." /></FormLabel>
              <Select
                labelId="demo-multi-select-label"
                id="demo-multi-select"
                value={bnb} // This will be an array
                onChange={(e) => setBnB(e.target.value)}
              >
                {users?.map((user) => (
                  <MenuItem key={user._id} value={user.BnBShortName}>
                    {user.BnBShortName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>

          <Stack mt={3}>
            <FormControl
              sx={{
                width: { xs: '100%', md: 490 },
              }}
            >
              <FormLabel sx={{ mb: 1 }}>Cleaning Item <InfoTooltip title="The type of cleaning task being requested for this extra visit." /></FormLabel>
              {/* <InputLabel id="demo-simple-select-label">BnB</InputLabel> */}
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={cleaningItem}
                // label="BnB"
                onChange={(e) => setCleaningItem(e.target.value)}
              >
                {cleaning?.map((user) => (
                  <MenuItem key={user._id} value={user.name}>
                    {user.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>

          <Stack mt={3} spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <DatePicker
              slotProps={{ textField: { size: 'medium' } }}
              label="Select Date"
              value={startDate}
              onChange={handleStartDateChange} // Capture date and update state
              renderInput={(params) => <TextField size="medium" {...params} />} // Optional: If you want to display a TextField
            />
          </Stack>

          <Stack mt={3}>
            <FormControl sx={{ width: { xs: '100%', md: 490 } }}>
              <FormLabel sx={{ mb: 1 }}>Select Time <InfoTooltip title="Time window during which the cleaner should carry out this extra cleaning." /></FormLabel>
              {/* <InputLabel id="demo-simple-select-label">BnB</InputLabel> */}
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={time}
                // label="BnB"
                onChange={(e) => setTime(e.target.value)}
              >
                <MenuItem value="7-12"> 7-12 </MenuItem>
                <MenuItem value="8-13"> 8-13 </MenuItem>
                <MenuItem value="9-14"> 9-14 </MenuItem>
                <MenuItem value="10-15"> 10-15 </MenuItem>
                <MenuItem value="11-16"> 11-16 </MenuItem>
                <MenuItem value="12-17"> 12-17 </MenuItem>
              </Select>
            </FormControl>
          </Stack>
        </Box>
        <LoadingButton
          sx={{
            width: 100,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Save
        </LoadingButton>
      </Card>
    </>
  );
};

export default AddExtraCleaningRequest;
